import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'lineNum',
     field: FIELDS.LINE_NUM,
     title: 'Line No',
     label: 'Line No',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'statusName',
     field: FIELDS.STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shippingProviderName',
     field: FIELDS.SHIPPING_PROVIDER_NAME,
     title: 'Ship Via',
     label: 'Ship Via',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingMethodName',
     field: FIELDS.SHIPPING_METHOD_NAME,
     title: 'Ship Method',
     label: 'Ship Method',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'internalPn',
     field: FIELDS.INTERNAL_PN,
     title: 'Internal PN',
     label: 'Internal PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'nsnNumber',
     field: FIELDS.NSNNUMBER,
     title: 'NSN Number',
     label: 'NSN Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'altNumber',
     field: FIELDS.ALT_NUMBER,
     title: 'Alt Number',
     label: 'Alt Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'sku',
     field: FIELDS.SKU,
     title: 'SKU',
     label: 'SKU',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'harmonizedCode',
     field: FIELDS.HARMONIZED_CODE,
     title: 'HTS No',
     label: 'HTS No',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'mfgName',
     field: FIELDS.MFG_NAME,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'altMfr',
     field: FIELDS.ALT_MFR,
     title: 'Alt Mfr',
     label: 'Alt Mfr',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'className',
     field: FIELDS.CLASS_NAME,
     title: 'Class',
     label: 'Class',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'categoryName',
     field: FIELDS.CATEGORY_NAME,
     title: 'Category',
     label: 'Category',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'uom',
     field: FIELDS.UOM,
     title: 'UOM',
     label: 'UOM',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Package',
     label: 'Package',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'piecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'leadFree',
     field: FIELDS.LEAD_FREE,
     title: 'RoHS',
     label: 'RoHS',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tempRating',
     field: FIELDS.TEMP_RATING,
     title: 'Temp Rating',
     label: 'Temp Rating',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'partComments',
     field: FIELDS.PART_COMMENTS,
     title: 'Item Comments',
     label: 'Item Comments',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'warehouseName',
     field: FIELDS.WAREHOUSE_NAME,
     title: 'Warehouse',
     label: 'Warehouse',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'location',
     field: FIELDS.LOCATION,
     title: 'Location',
     label: 'Location',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'returnReasonName',
     field: FIELDS.RETURN_REASON_NAME,
     title: 'Return Reason',
     label: 'Return Reason',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCode',
     field: FIELDS.DATE_CODE,
     title: 'Date Code',
     label: 'Date Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'countryOfOriginName',
     field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
     title: 'COO',
     label: 'COO',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'ordered',
     field: FIELDS.ORDERED,
     title: 'Qty Ordered',
     label: 'Qty Ordered',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'returned',
     field: FIELDS.RETURNED,
     title: 'Qty Returning',
     label: 'Qty Returning',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'cost',
     field: FIELDS.COST,
     title: 'Unit Cost',
     label: 'Unit Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'currencyTypeName',
     field: FIELDS.CURRENCY_TYPE_NAME,
     title: 'Currency',
     label: 'Currency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'exchangeRate',
     field: FIELDS.EXCHANGE_RATE,
     title: 'Exch. Rate',
     label: 'Exch. Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'lineTotal',
     field: FIELDS.LINE_TOTAL,
     title: 'Total Cost',
     label: 'Total Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'endLineUsage',
     field: FIELDS.END_LINE_USAGE,
     title: 'End Line Usage',
     label: 'End Line Usage',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'vendorDate',
     field: FIELDS.VENDOR_DATE,
     title: 'Vendor Date',
     label: 'Vendor Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'lotCode',
     field: FIELDS.LOT_CODE,
     title: 'Lot Code',
     label: 'Lot Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'binNumber',
     field: FIELDS.BIN_NUMBER,
     title: 'Bin',
     label: 'Bin',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'customerPn',
     field: FIELDS.CUSTOMER_PN,
     title: 'Customer PN',
     label: 'Customer PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tariffCode',
     field: FIELDS.TARIFF_CODE,
     title: 'Tariff Code',
     label: 'Tariff Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'revision',
     field: FIELDS.REVISION,
     title: 'Revision',
     label: 'Revision',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'origin',
     field: FIELDS.ORIGIN,
     title: 'Origin',
     label: 'Origin',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'specs',
     field: FIELDS.SPECS,
     title: 'Specs',
     label: 'Specs',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'lineType',
     field: FIELDS.LINE_TYPE,
     title: 'LineType',
     label: 'LineType',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'qtyBin',
     field: FIELDS.QTY_BIN,
     title: 'Qty Bin',
     label: 'Qty Bin',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tested',
     field: FIELDS.TESTED,
     title: 'Tested',
     label: 'Tested',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'model',
     field: FIELDS.MODEL,
     title: 'Model',
     label: 'Model',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'pmaNumber',
     field: FIELDS.PMANUMBER,
     title: 'PMA Number',
     label: 'PMA Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'cageCode',
     field: FIELDS.CAGE_CODE,
     title: 'Cage Code',
     label: 'Cage Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'eucRequired',
     field: FIELDS.EUC__REQUIRED,
     title: 'EUC_Required',
     label: 'EUC_Required',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'replacedByPn',
     field: FIELDS.REPLACED_BY_PN,
     title: 'Replaced By PN',
     label: 'Replaced By PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'approvalBasis',
     field: FIELDS.APPROVAL_BASIS,
     title: 'Approval Basis',
     label: 'Approval Basis',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'createdByUser',
     field: FIELDS.CREATED_BY_USER,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUser',
     field: FIELDS.MODIFIED_BY_USER,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
